import React from 'react'
import Link from 'next/link'
import { THEME } from 'utils'

const SecondaryCard = ({ title, description, image, link, reverse }) => {
  return (
    <div className='secondaryCard'>
      <img src={image} alt={title} />
      <div className='secondaryCard__info'>
        <h2>{title}</h2>
        <h5>{description}</h5>
        <Link href={link}>
          <a>
            <button className='btn'>Learn More</button>
          </a>
        </Link>
      </div>
      <style jsx>{`
        .secondaryCard {
          display: flex;
          flex-direction: column;
          background-color: #fff;
          width: 95%;
          margin: 10px auto;
        }
        .secondaryCard__info {
          padding: 18px;
        }
        .secondaryCard h2 {
          margin: 0;
          font-size: 1.2rem;
        }
        .secondaryCard h5 {
          margin: 5px 0 20px;
          font-size: 0.75rem;
        }
        .secondaryCard img {
          background-color: #eaeced;
          width: 100%;
          height: 190px;
          object-fit: cover;
          object-position: center center;
        }
        .secondaryCard .btn {
          text-transform: capitalize;
          background-color: #fff;
          border: 2px solid #000;
          color: #000;
          width: 100px;
          font-size: 0.7rem;
          margin: 0;
          padding: 4px 0;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .secondaryCard {
            flex-direction: ${reverse ? 'row-reverse' : 'row'};
            margin: 0 auto;
          }
          .secondaryCard__info {
            width: 100%;
            padding: 0 3.5%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
          }
          .secondaryCard h2 {
            font-size: 0.8rem;
          }
          .secondaryCard h5 {
            margin: 5px 0 15px;
            font-size: 0.55rem;
          }
          .secondaryCard img {
            max-width: 50%;
            height: 160px;
          }
          .secondaryCard .btn {
            width: 80px;
            border-width: 1px;
            font-size: 0.5rem;
            padding: 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .secondaryCard {
            width: 100%;
          }
          .secondaryCard__info {
            padding: 0 3.5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .secondaryCard h2 {
            font-size: 0.8rem;
          }
          .secondaryCard h5 {
            margin: 5px 0 15px;
            font-size: 0.55rem;
          }
          .secondaryCard img {
            width: 50%;
            height: 1%;
          }
          .secondaryCard .btn {
            width: 80px;
            font-size: 0.5rem;
            padding: 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .secondaryCard img,
          .secondaryCard__info {
            height: 260px;
          }
          .secondaryCard__info {
            padding: 0 3.5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .secondaryCard h2 {
            font-size: 1rem;
          }
          .secondaryCard h5 {
            margin: 5px 0 15px;
            font-size: 0.75rem;
          }
          .secondaryCard .btn {
            width: 90px;
            font-size: 0.6rem;
            padding: 2px 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .secondaryCard img,
          .secondaryCard__info {
            height: 274px;
          }
          .secondaryCard__info {
            padding: 0 3.5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .secondaryCard h2 {
            font-size: 1.1rem;
          }
          .secondaryCard h5 {
            margin: 5px 0 15px;
            font-size: 0.85rem;
          }
          .secondaryCard .btn {
            width: 100px;
            font-size: 0.65rem;
            padding: 2px 0;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .secondaryCard img {
            height: 310px;
            width: auto;
          }
          .secondaryCard__info {
            padding: 0 3.5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .secondaryCard h2 {
            font-size: 1.3rem;
          }
          .secondaryCard h5 {
            width: 85%;
            margin: 5px 0 20px;
            font-size: 0.95rem;
          }
          .secondaryCard .btn {
            width: 100px;
            border-width: 2px;
            font-size: 0.65rem;
            padding: 2px 0;
          }
        }
      `}</style>
    </div>
  )
}

const SecondaryFlex = ({ items }) => (
  <div style={{ width: '100%', padding: '0 8px 8px' }}>
    {items.map((item, idx) => (
      <SecondaryCard key={idx} reverse={idx % 2 === 0} {...item} />
    ))}
  </div>
)

export default SecondaryFlex
